<template>
  <div class="bottom-wrap">
    <img class="bg" src="../../../assets/images/mobile/b1.jpg">
    <div class="ewm-box">
      <img src="../../../assets/images/contact/ewm.png">
      <span class="desc">扫码联系我们</span>
    </div>
    <div class="right-box">
      <p>电话: <a style="color: blue" @click="callPhone(phone)">{{ phone }}</a> (张先生)</p>
<!--      <p>地址: 浙江省台州市椒江区洪家联合钢材五金市场C区576-582号 </p>-->
      <p @click="openLink">浙ICP备2023034112号-1 </p>
      <p>Copyright© 版权所有: 浙江台州市椒江敏伟矿山机械经营部</p>

    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  data () {
    return {
      phone: '13905764593'
    }
  },
  methods: {
    callPhone (phoneNumber) {
      window.location.href = 'tel://' + phoneNumber
    },
    openLink () {
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-wrap {
  width: calc(100% - 0.64rem);
  height: 5.4rem;
  overflow: hidden;
  position: relative;
  //background-image: url('../../../assets/images/mobile/b1.jpg');
  //background-size: cover;
  //background-repeat: no-repeat;
  //background-attachment: fixed;
  display: flex;
  align-items: center;
  padding: 0.32rem;
  .bg {
    width: 100%;
    height: 6rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
  }
  .ewm-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.16rem;
    img {
      width: 3.5rem;
      height: 3.5rem;
    }
    .desc {
      margin-top: 0.4rem;
      font-size: 0.4rem;
    }
  }
  .right-box {
    margin-left: 0.2rem;
    p {
      font-size: 0.4rem;
    }
  }
}
</style>
